var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("AddForm", {
        ref: "addFormRef",
        attrs: { "business-type": _vm.ORDER_BUSINESS_TYPES.COMMON },
        on: { onSave: _vm.onSave },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }